export default "__VITE_ASSET__efd3ee47__"